import React from 'react';
import * as Opt from '../editor/Helpers';
import MediaSelector from '../editor/fields/MediaSelector';
import { CalculateSpacing } from '../editor/Helpers';

class Avatar extends React.Component{
    constructor(props){
        super(props)
        this.state={


        }
    }

    render(){
        return <div className={`${window.location.pathname.includes('editor') && (["dt", "mob"].filter((i) => i === this.props.visibility).length) ? 'opacity-50 flex' : this.props.visibility == "dt" ? 'hidden lg:flex' : this.props.visibility == "mob" ? 'lg:hidden' : 'flex'} w-full flex-wrap lg:flex-nowrap  ${CalculateSpacing(this.props.spacing)}`}>
            <div className='flex flex-wrap items-center lg:flex-nowrap'>
                {/* Avatar here */}
                {this.props.showAvatarImage && <img style={{ height: "64px", width:"64px", objectFit:"cover"}} alt={this.props.avatarAlt} src={`${this.props.avatarSrc}`} className={`max-w-full h-auto rounded-[50%] lg:mr-[10px] ${this.props.hideAvatarOnlyMobile ? 'hidden md:flex' : ''}`} />}
                <div className='mt-[10px] ml-[10px] lg:mt-0'>
                    <p className={`mb-0 fs-6 font-medium ${this.props?.fontColor ?? ''}`}>{this.props.name}</p>
                    <p className={`mb-0 fs-6 ${this.props?.fontColor ?? ''}`}>{this.props.company}</p>
                </div>
            </div>
            {this.props.showCompanyImage && (
              <>
              <div className={`mx-[10px] border-[2px] border-${this.props.borderColor} border-start lg:block`}></div>
                {/* Image here */}
              <div className={`mt-[10px] lg:mt-0 flex items-center`}>
                <img style={{ height: "32px", objectFit:"contain" }} alt={this.props.imageAlt} src={`${this.props.imageSrc}`} className='max-w-full h-auto' />
              </div>
            </>)}
        </div>
    }
}

Avatar.defaultProps = {
    visibility: "",
    showAvatarImage: false,
    showCompanyImage: true,
    hideAvatarOnlyMobile: false,
    avatarSrc: "https://placehold.co/600x400",
      avatarAlt: "scenic image",
      name: 'Name Surname',
      // nameColor: 'neutral-charcoal',
      company: 'Position, Company name',
      // companyColor: 'neutral-charcoal', // unused – name/company use fontColor
      borderColor: 'neutral-charcoal',
      //image
      imageSrc: "https://placehold.co/600x400",
      imageAlt: "scenic image",
      spacing: [],
}
  
Avatar.fields = {
    visibility: {
      type: "select",
      options: Opt.visibilityOptions
    },
    showAvatarImage:{
        type: "radio",
        options:[
            {label: "No", value: false},
            {label: "Yes", value: true}
        ]
    },
    showCompanyImage:{
      type: "radio",
      options:[
          {label: "No", value: false},
          {label: "Yes", value: true}
      ]
    },
    hideAvatarOnlyMobile: {
      type: "radio",
      options: [
          { label: "No", value: false },
          { label: "Yes", value: true }
      ]
    },
    avatarSrc: {
        type: "custom",
        render: ({ name, onChange, value }) => <MediaSelector name={name} type={'img'} onChange={onChange} value={value} />,
      },
      avatarAlt: {
        type: "text"
      },
      name: { type: "text" },
      // nameColor: {
      //   type: "select",
      //   options: Opt.colorVariables
      // },
      company: { type: "text" },
      // companyColor: { type: "select", options: Opt.colorVariables }, // unused
      borderColor: {
        type: "select",
        options: Opt.colorVariables
      },
      imageSrc: {
        type: "custom",
        render: ({ name, onChange, value }) => <MediaSelector name={name} type={'img'} onChange={onChange} value={value} />,
      },
      imageAlt: {
        type: "text"
      },
      spacing: Opt.spacingOptions,
}

export default Avatar;

